import { FontSize, Text } from 'src/components';
import { i18n } from "src/common";
import { colors } from "src/theme";
import parse from 'html-react-parser';

export interface HtmlTextProps {
  text?: string;
  i18nKey?: string;
  links?: Array<HtmlTextLink>;
  textSize?: FontSize;
  textColor?: string;
}

export interface HtmlTextLink {
  value: string;
  link: string;
  translation: string;
}

export const HtmlText = ({ text = '', i18nKey, links, textSize = "small", textColor = colors.text1 }: HtmlTextProps) => {

  const displayText = i18nKey && !links ? i18n.t(i18nKey) : text;

  const createTextWithLinks = (translationKey: string, footerLinks: Array<HtmlTextLink>) => {
    let inputString = i18n.t(translationKey);
    footerLinks.forEach(fl => {
      inputString = inputString.replace(`{${fl.value}}`, `<a style="color: ${colors.primary}" href="${fl.link}" target="_blank" rel="noreferrer">${fl.translation}</a>`);
    });

    return parse(inputString);
  }

  return (
    <Text type={textSize} color={textColor}>{i18nKey && links?.length ? createTextWithLinks(i18nKey, links) : displayText}</Text>
  )
};
